import { render } from "./Puntos.vue?vue&type=template&id=17c6dab4&scoped=true"
import script from "./Puntos.vue?vue&type=script&lang=js"
export * from "./Puntos.vue?vue&type=script&lang=js"

import "./Puntos.vue?vue&type=style&index=0&id=17c6dab4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-17c6dab4"

export default script